import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, SubmitInput, Error, Success } from './styles';
import { useAdminFunction } from '../../hooks/useAdminFunction';
import { AWSStatusIndicator } from '../../components';

// JsonTable component
interface JsonTableProps {
  data: Array<NotificationListObject>;
}

interface NotificationListObject {
  date: string;
  hour: number;
  text: string;
  _id: any;
}

const JsonTable = ({ data }: JsonTableProps) => {
  if (!data) return null;
  return (
    <div style={{ overflowY: 'auto', height: '300px' }}>
      <table style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid black' }}>ID</th>
            <th style={{ border: '1px solid black' }}>Name</th>
            <th style={{ border: '1px solid black' }}>Age</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td style={{ border: '1px solid black' }}>{item._id.toString()}</td>
              <td style={{ border: '1px solid black' }}>{item.date}</td>
              <td style={{ border: '1px solid black' }}>{item.hour}</td>
              <td style={{ border: '1px solid black' }}>{item.text}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// EditNotifications component
const EditNotifications: React.FC = () => {
  const navigate = useNavigate();
  const { callFunction, isAuthenticated } = useAdminFunction();
  const [error, setError] = useState<string>('');
  const [success] = useState<string>('');
  const [jsonData, setJsonData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleListMassNotifications = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setError('');
    
    if (!isAuthenticated) {
      navigate('/admin/login');
      return;
    }

    setIsLoading(true);

    try {
      const result = await callFunction('listMassNotifications', {});
      console.log('Mass notifications result:', result);
      setJsonData(result || []);
    } catch (error: any) {
      console.error('Failed to list notifications:', error);
      setError(error?.message || error?.error || 'Failed to list notifications');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AWSStatusIndicator />
      <Form onSubmit={handleListMassNotifications}>
      <SubmitInput type="submit" value={isLoading ? "Loading..." : "List notifications"} disabled={isLoading || !isAuthenticated} />
        {error.length > 0 && <Error>{error}</Error>}
        {success.length > 0 && <Success>{success}</Success>}
        {jsonData.length > 0 && <JsonTable data={jsonData} />}
      </Form>
    </>
  );
};

export { EditNotifications };
